import React from 'react';
import TagManagerService from 'services/TagManager';
import style from './style.scss'; //NOSONAR

const SocialLinks = () => {

    const clickLinkFooter = (action, tag) => {
        TagManagerService.footer(action, tag);
    }

    return(
        <div className='footer-social-links'>
            <a onClick={() => clickLinkFooter('Contáctanos', 'Facebook')} href='https://www.facebook.com/jumbochile?fref=ts' target="_blank" rel="noopener noreferrer" className='font-icn facebook mobile-click' aria-label="Jumbo Facebook"></a>
            <a onClick={() => clickLinkFooter('Contáctanos', 'instagram')} href='https://www.instagram.com/jumbochile/?hl=es' target="_blank" rel="noopener noreferrer" className='font-icn instagram mobile-click' aria-label="Jumbo instagram"></a>
            <a onClick={() => clickLinkFooter('Contáctanos', 'Twitter')} href='https://twitter.com/jumbochile' target="_blank" rel="noopener noreferrer" className='font-icn twitter mobile-click' aria-label="Jumbo Twitter"></a>
            <a onClick={() => clickLinkFooter('Contáctanos', 'Youtube')} href='https://www.youtube.com/user/SupermercadoJumbo' target="_blank" rel="noopener noreferrer" className='font-icn youtube mobile-click' aria-label="Jumbo Youtube"></a>
        </div>
    )
}

export default SocialLinks;
